module.exports = __webpack_public_path__ + "platform/static/media/risk.3b7129b9.png";